import * as React from "react";
type Props = {
  className?: string,
};
function SvgHighFiber({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-HighFiber"
      className={className}
    >
      <path
        d="M14.405 14.7874C13.3672 15.6616 12.774 16.8583 12.6168 18.106C12.4723 18.1718 12.3282 18.2386 12.1799 18.2904C10.8063 17.3137 9.05375 17.0714 7.48213 17.619C7.13241 17.3703 6.79954 17.0912 6.51029 16.7481C4.66521 14.5577 4.94496 11.2864 7.13522 9.44117C9.32548 7.59596 12.5969 7.87571 14.4421 10.0661C15.413 11.2187 15.7799 12.6683 15.6053 14.0541C15.1845 14.2457 14.7759 14.475 14.405 14.7874ZM14.405 14.7874C16.5953 12.9422 19.8667 13.222 21.7119 15.4123C23.557 17.6026 23.2773 20.874 21.087 22.719C18.8968 24.5643 15.6254 24.2845 13.7803 22.0941M14.405 14.7874C12.2148 16.6326 11.9351 19.9039 13.7803 22.0941M13.7803 22.0941C12.9267 21.0809 12.5477 19.8369 12.5823 18.6092C10.6877 16.954 7.82827 16.8655 5.84471 18.5366C3.65443 20.3818 3.37468 23.6532 5.21978 25.8433C7.065 28.0334 10.3363 28.3132 12.5265 26.4682C13.7037 25.4765 14.3091 24.0728 14.3493 22.6464M13.7803 22.0941C13.9545 22.3008 14.1518 22.4738 14.3493 22.6464M14.3493 22.6464C15.5354 23.6828 17.0906 24.0952 18.5845 23.851C18.831 24.9049 19.2038 25.4865 19.2038 25.4865L23.5465 33.8135C23.4337 35.2865 21.2948 35.9608 21.2948 35.9608C19.23 36.2288 18.3235 35.035 18.3235 35.035L14.6864 28.8917C13.8967 27.7286 13.1317 26.865 12.6381 26.3511C13.7333 25.3671 14.3106 24.0216 14.3493 22.6464ZM29.4447 22.5619V3.76808M23.8064 9.17898L29.414 3L35.0828 9.24628"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgHighFiber;
